export default __webpack_public_path__ + "static/media/no-comments.73e4bf10.svg";